import * as R from "ramda";

export const getRequirementIDs = R.propOr([], "requirement_ids");
export const getHandoffSections = R.propOr([], "handoff_sections");
export const getHighlightMessageMarkdown = R.prop("highlight_message_markdown");
export const getType = R.prop("guide_type");
export const getTitle = R.prop("title");
export const getDescription = R.prop("description");
export const getCallToAction = R.prop("call_to_action");
export const getSubmissionTimeframeMarkdown = R.prop("submission_timeframe_markdown");
export const isZoning = R.propEq("zoning", "guide_type");
export const isRequirementCatalog = R.propEq("requirement_catalog", "guide_type");
export const overridesRequirementCalculation = R.prop("override_requirement_calculation");
export const getHandoffInstructions = R.prop("handoff_instructions_markdown");
export const getUseCodeFilters = R.propOr([], "use_code_filters");
